import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function RegisteredPracticalNurses() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-974">
      <Navbar data-id="element-975" />
      <main className="flex-1" data-id="element-976">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-977">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-978">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-979">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-980" />
              Services
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-981">
              Registered Practical Nurses (RPN)
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-982">
              Skilled clinical support, medication management, and direct
              patient care.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-983">
          <p data-id="element-984">
            Our Registered Practical Nurses (RPNs) provide vital clinical
            support and direct patient care. They are trained to administer
            medications, perform assessments, and assist with complex care needs
            under the guidance of a Registered Nurse or physician.
          </p>
          <p data-id="element-985">
            We connect facilities with experienced RPNs who are fully vetted,
            licensed, and ready to step into any healthcare setting. From
            long-term care facilities to community health centers, our RPNs
            deliver high-quality, compassionate care.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-986" />
    </div>;
}